import React, { useState, useEffect } from 'react';
import { UserProvider, useUser } from '../../context/UserContext'
import Svg from '../../static/user.svg'

import IconMusica from "../../static/intereses/musica.png";
import IconDeporte from "../../static/intereses/deporte.png";
import IconComida from "../../static/intereses/comida.png";
import IconAnimales from "../../static/intereses/animales.png";
import IconViajes from "../../static/intereses/viajes.png";
import IconMarcas from "../../static/intereses/marcas.png";

console.log("ACA");
console.log(IconMusica);
let Item = ( { data } ) => {
  return (
    <div className="item">
      <div className="icon">
        <img src={data.icon} alt={data.title}/>
      </div>
      <div className="detail">
        <h5>{data.title}</h5>
        <strong>{data.percent}%</strong>
        <div className="progressbar">
          <div className="indicator" style={ { width: data.percent + '%'} }></div>
        </div>
      </div>
    </div>
  )
}

let BoxIntereses = ( { data } ) => {
  
  const [listIntereses, setListIntereses] = useState([]);
  
  const { usuario, cargandoUsuario, setCargandoUsuario, setData, login, setLogin, logout, FBLogin } = useUser();
  
  useEffect( () => {
    setListIntereses([
      {
        icon: IconMusica,
        title: 'Música y baile',
        percent: Math.floor(Math.random() * 100) + 1
      },
      {
        icon: IconDeporte,
        title: 'Deportes y entretenimiento',
        percent: Math.floor(Math.random() * 100) + 1
      },
      {
        icon: IconComida,
        title: 'Comida y cocina',
        percent: Math.floor(Math.random() * 100) + 1
      },
      {
        icon: IconAnimales,
        title: 'Mascotas y medioambiente',
        percent: Math.floor(Math.random() * 100) + 1
      },
      {
        icon: IconViajes,
        title: 'Viajes y lugares',
        percent: Math.floor(Math.random() * 100) + 1
      },
      {
        icon: IconMarcas,
        title: 'Marcas y empresas',
        percent: Math.floor(Math.random() * 100) + 1
      },
    ])
    
  }, [usuario]);
  
  return (
    <section className="box_intereses" style={{ opacity : cargandoUsuario == true ? 0 : 1 }}>
      <div className="header">
        <h3>% de interes en común</h3>
        <h4>con las personas apoyando</h4>
      </div>
      {listIntereses.map( (item, i) => {
        return (<Item data={item} key={"interes_" + i}/>)
      })}
    </section>
  )
}

export default BoxIntereses